import type { InferResponse } from '@/hooks/useApiClient'
import type { SSOIdentityProvider } from '@gravitate-js/excalibrr/dist'
import { useQuery } from '@tanstack/react-query'
import { getAPIURL } from '@utils/api'

export type SetupData = InferResponse<'/setup'> & { ssoProviders: SSOIdentityProvider[] }

export function useSetup() {
  return useQuery<SetupData>({
    queryKey: ['setup'],
    queryFn: async () => {
      const baseUrl = getAPIURL()
      const resp = await fetch(`${baseUrl}setup`)
      if (!resp.ok) {
        throw new Error('Network response was not ok')
      }
      const json = await resp.json()
      json.ssoProviders = getSSOProviders(json)

      return json
    },
  })
}

function getSSOProviders(data: SetupData): SSOIdentityProvider {
  return data?.sso_providers?.map((p) => ({
    IdentityProviderId: p.provider,
    Name: p.display_name,
    ClientId: p.client_id,
    Provider: p.provider,
    RedirectUri: p.redirect_uri,
    AuthorizeUrl: p.authorization_url,
    Scopes: p.scopes.join(' '),
  }))
}
